
enum Stage {
  Staging = 'staging',
  Prod = 'prod'
}

export default Stage;
